import AdminContainer from './AdminContainer';

export default AdminContainer;
